import React from 'react';
import SvgIcon from '../SvgIcon';
var CartIcon = function CartIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 7H5.82L5 2.8A1 1 0 004 2H0v2h3.18L7 23.2a1 1 0 001 .8h18v-2H8.82L8 18h18a1 1 0 001-.78l2-9A1 1 0 0028 7zm-2.8 9H7.62l-1.4-7h20.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z",
    fill: "none"
  }));
};
export default CartIcon;